import React, { useState } from 'react';
import styles from './ManageProducts.module.scss';
import { Col, Container, Row } from 'reactstrap';
import FilterTabs from '../../../../components/SellerPortalComponents/FilterTabs/FilterTabs';
import AllProducts from '../../../../components/SellerPortalComponents/ManageProductsTabs/AllProducts/AllProducts';
import ActiveProducts from '../../../../components/SellerPortalComponents/ManageProductsTabs/ActiveProducts/ActiveProducts';
import UnderApprovalProducts from '../../../../components/SellerPortalComponents/ManageProductsTabs/UnderApprovalProducts/UnderApprovalProducts';
import InactiveOutOfStockProducts from '../../../../components/SellerPortalComponents/ManageProductsTabs/InactiveProducts/InactiveOutOfStockProducts';
import RestrictedProducts from '../../../../components/SellerPortalComponents/ManageProductsTabs/InactiveProducts/RestrictedProducts/RestrictedProducts';
import DeletedProducts from '../../../../components/SellerPortalComponents/ManageProductsTabs/InactiveProducts/DeletedProducts/DeletedProducts';

const ManageProducts = () => {
    const [activeTab, setActiveTab] = useState('all');
    const [inactiveTabState, setInactiveTabState] = useState('outOfStock');

    const renderTable = () => {
        switch (activeTab) {
            case 'active':
                return <ActiveProducts />;
            case 'underApproval':
                return <UnderApprovalProducts />;
            case 'inactive':
                switch (inactiveTabState) {
                    case 'restricted':
                        return <RestrictedProducts />;
                    case 'deleted':
                        return <DeletedProducts />;
                    default:
                        return <InactiveOutOfStockProducts />;
                }
            default:
                return <AllProducts />;
        }
    };

    return (
        <div className={styles.mainManageProductsContainer}>

            <h4 className={styles.sectionHeading}>Manage Products</h4>

            <Container fluid className={styles.manageProducts}>
                <Row className='g-0'>
                    <Col xs="12">
                        <FilterTabs 
                            activeTab={activeTab} 
                            setActiveTab={setActiveTab} 
                            inactiveTabState={inactiveTabState}
                            setInactiveTabState={setInactiveTabState}
                        />
                    </Col>
                </Row>

                <Row className='g-0'>
                    <Col>
                        {renderTable()}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ManageProducts;
